import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
    ConfigConstants,
    ConfigService,
    DateUtilities,
    TimesheetAndExpensesService,
    WeeklyWorkTimeService,
    WorkdayModel,
} from '@evorait/pace-core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'pace-weekly-work-time',
    templateUrl: './weekly-work-time.component.html',
    styleUrls: ['./weekly-work-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeeklyWorkTimeComponent implements OnInit, OnChanges {
    @Input()
    public isWorkStartedForToday: boolean;

    public maxWorkingHours = ConfigConstants.totalWorkingHours;
    public totalDurationOfTheWeek: string;
    public statusBarText = '';
    public statusBarType = 'default';

    public weeklyWorkTimeList$: Observable<WorkdayModel[]>;
    public constructor(
        private readonly translate: TranslateService,
        private readonly timesheetAndExpensesService: TimesheetAndExpensesService,
        private readonly weeklyWorkTimeService: WeeklyWorkTimeService,
        private readonly configService: ConfigService,
    ) {
        this.weeklyWorkTimeList$ = this.weeklyWorkTimeService.updateWeeklyWorkTimeValue$.pipe(
            tap(() => this.setWorkTimeDependency()),
        );
    }

    public ngOnInit(): void {
        this.setWorkTimeDependency();
    }

    public ngOnChanges(changesObj: SimpleChanges): void {
        if (changesObj.isWorkStartedForToday) {
            this.isWorkStartedForToday = <boolean>changesObj.isWorkStartedForToday.currentValue;
            this.customizeStatusBar();
        }
    }

    public formatDate(date: moment.Moment): string {
        if (date.isSame(moment(), 'days')) {
            return <string>this.translate.instant('WEEKLY_WORK_HOUR_TODAY_LABEL');
        }
        // return date.format(ConfigConstants.formatPatternDateGenericWithDay);
        return DateUtilities.formatDate(date);
    }

    public isWeeklyWorkHoursExceeded(): boolean {
        const maxWeeklyWorkingHours = this.configService.getMaxWeeklyWorkingHours();
        const weeklyWorkHours = <number>this.weeklyWorkTimeService.getTotalWeekDuration(false);

        return weeklyWorkHours >= maxWeeklyWorkingHours;
    }

    private setWorkTimeDependency(): void {
        const startOfWork = this.timesheetAndExpensesService.getStartOfWork();

        if (startOfWork.isValid()) {
            const totalDuration =
                this.timesheetAndExpensesService.getTotalDurationOfCurrentTimesheetEntries() ?? moment.duration(0);

            this.weeklyWorkTimeService.updateTotalDurationForSpecificDate(
                this.timesheetAndExpensesService.getStartOfWork(),
                totalDuration,
            );
        }
        this.totalDurationOfTheWeek = <string>this.weeklyWorkTimeService.getTotalWeekDuration();
        this.customizeStatusBar();
    }
    /**
     * This function is to set weekly work time HTML table dependency
     * Check, if Work duration Exceed NINE hours but less than TEN hours- Status bar color should be Light orange and update table progress bar text
     * Check if Work duration Exceed TEN Hours - Status bar color should be  orange (dark) and update status bar text
     */
    private customizeStatusBar(): void {
        const workStatus = this.weeklyWorkTimeService.getStatusBarDetails(this.isWorkStartedForToday);

        this.statusBarType = workStatus?.type ?? '';
        this.statusBarText = workStatus?.text ?? '';
    }
}
